import React, { memo, useState } from 'react';
import useEnterOrSpaceKey from 'Components/Hooks/UseEnterOrSpaceKey';
import i18n from 'i18next';
import { HbtIcon } from '../HbtIcon';
import { HbtIconSize } from '../HbtIcon/types';
import styles from './styles.module.scss';
import { TagProps, TagVariant } from './types';

export const Tag: React.FC<TagProps> = memo(
  ({ label, tagVariant, tagType, statusIndicator, leadingIcon, onDelete }: TagProps) => {
    const [announcement, setAnnouncement] = useState<string | null>(null);

    const handleDelete = () => {
      setAnnouncement(`${label} ${tagType} has been removed.`);
      if (onDelete) {
        setTimeout(() => onDelete(), 100);
      }
      setTimeout(() => setAnnouncement(null), 1000);
    };

    const statusLabel = i18n.t('Status-Label') ?? 'status';
    const readLabelCopy = i18n.t('Read-Label-Copy') ?? 'read label copy';
    const removeLabel = i18n.t('Remove-Label') ?? 'remove';

    const StatusTagMapping: Record<string, string> = {
      Grey: 'icon_grey_status',
      Orange: 'icon_orange_status',
      Red: 'icon_red_status',
      Green: 'icon_green_status',
      Blue: 'icon_blue_status'
    };

    const tagStateIcon = (
      <HbtIcon
        size={HbtIconSize.SMALL}
        type={StatusTagMapping[statusIndicator!]}
        aria-label={statusLabel}
      />
    );

    const tagCloseIcon = <HbtIcon size={HbtIconSize.SMALL} type="icon_close" />;

    return (
      <>
        <div
          aria-label={readLabelCopy}
          data-testid="tag-test"
          className={
            tagVariant === TagVariant.INTERACTIVE
              ? styles.containerInteractive
              : styles.containerStatic
          }
        >
          {tagVariant === TagVariant.INTERACTIVE && (
            <>
              {leadingIcon && <div className={styles.checkStyle}>{leadingIcon}</div>}
              {statusIndicator && <div>{tagStateIcon}</div>}
            </>
          )}
          <div className={styles.labelStyle}>{label}</div>
          {tagVariant === TagVariant.INTERACTIVE && (
            <button
              onClick={handleDelete}
              onKeyDown={useEnterOrSpaceKey(handleDelete)}
              className={styles.closeStyle}
              aria-label={`${removeLabel} ${label} ${tagType}`}
            >
              {tagCloseIcon}
            </button>
          )}
        </div>
        <div role="status" aria-live="assertive" className={styles.srAnnouncementStyle}>
          {announcement}
        </div>
      </>
    );
  }
);
